import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const FluentDataBarHorizontalIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M2.40002 19.2C2.40002 20.5255 3.47454 21.6 4.80002 21.6C6.12551 21.6 7.20002 20.5255 7.20002 19.2L7.20002 13.2C7.20002 11.8745 6.12551 10.8 4.80002 10.8C3.47454 10.8 2.40002 11.8745 2.40002 13.2L2.40002 19.2ZM9.60002 19.2C9.60002 20.5255 10.6745 21.6 12 21.6C13.3255 21.6 14.4 20.5255 14.4 19.2L14.4 9.59998C14.4 8.27446 13.3255 7.19997 12 7.19997C10.6745 7.19997 9.60002 8.27446 9.60002 9.59998L9.60002 19.2ZM16.8 19.2C16.8 20.5255 17.8745 21.6 19.2 21.6C20.5255 21.6 21.6 20.5255 21.6 19.2L21.6 4.79997C21.6 3.47445 20.5255 2.39997 19.2 2.39997C17.8745 2.39997 16.8 3.47445 16.8 4.79997L16.8 19.2Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
